import React, { useEffect, useState, useRef } from 'react';
import { observer } from 'mobx-react';
import EditSingleElement from './EditSingleElement';
import { useStore } from '../../../store/storeUtils';
const CMSEditElementsContainer = observer(({
  renderCustomCss
}) => {
  const store = useStore();
  const [elements, setElements] = useState([]);
  const elementsRef = useRef([]);
  const setElementsRef = data => {
    elementsRef.current = data;
    setElements(data);
  };
  const setCss = (map = {}) => {
    // controllo esistenza
    const currentConfig = store.previewConfiguration || {
      configuration: {}
    };
    if (!currentConfig.configuration) {
      currentConfig.configuration = {
        customCss: {}
      };
    } else if (currentConfig.configuration && !currentConfig.configuration.customCss) {
      currentConfig.configuration.customCss = {};
    }
    // per ogni oggetto
    Object.keys(map).forEach(id => {
      currentConfig.configuration.customCss = {
        ...currentConfig.configuration.customCss,
        [id]: map[id]
      };
    });

    // sync
    store.setRenderPreviewConfiguration(store.previewConfiguration);
    store.synchronizeWholeConfiguration();
    if (renderCustomCss) {
      renderCustomCss();
    }

    // workaround per il refresh dell'array degli elementi
    const event = new Event('cssConfiguratorToggle'); // Dispatch the event.
    window.dispatchEvent(event);
    setTimeout(() => {
      window.dispatchEvent(event);
    }, 100);
  };

  // eslint-disable-next-line
  const getElements = () => {
    if (elementsRef.current.length === 0) {
      const elementsToConsider = Array.from(document.getElementsByClassName('edit-custom-css'));
      setElementsRef(elementsToConsider);
    } else {
      setElementsRef([]);
    }
  };

  // eslint-disable-next-line
  const cssConfiguratorClose = () => {
    setElementsRef([]);
  };
  useEffect(() => {
    window.addEventListener('cssConfiguratorToggle', getElements);
    window.addEventListener('cssConfiguratorClose', cssConfiguratorClose);
    return () => {
      window.removeEventListener('cssConfiguratorToggle', getElements);
      window.addEventListener('cssConfiguratorClose', cssConfiguratorClose);
    };

    // eslint-disable-next-line
  }, []);
  const currentCustomCss = store.previewConfiguration && store.previewConfiguration.configuration && store.previewConfiguration.configuration.customCss ? store.previewConfiguration.configuration.customCss : {};
  return elements.filter(el => el.getAttribute('data-custom-css-menu') !== null).map(el => {
    return /*#__PURE__*/React.createElement(EditSingleElement, {
      id: el.getAttribute('data-custom-css-id'),
      menuType: el.getAttribute('data-custom-css-menu'),
      setCss: setCss,
      htmlElement: el,
      allElements: elements,
      currentCustomCss: currentCustomCss
    });
  });
});
export default CMSEditElementsContainer;